import { IoChevronForward, IoLocationOutline } from 'react-icons/io5';
import { Link } from 'react-router-dom';
import { WAITLIST_STATUS_OPTIONS } from '../../../components/traffic-light-toggle';
import { DASHBOARD_SOURCE } from '../dashboard.service';
import DashboardSection from './DashboardSection';

// Same code mapping as the centre screen (CentreWaitlistStatusCard): 1 green, 2 amber, 3 red.
const STATUS_BY_CODE = { 1: 'green', 2: 'amber', 3: 'red' };

const GROUPS = [
	{ key: 'u2', label: 'Under 2', statusField: 'waitlistTourStatusU2', notesField: 'waitlistTourStatusNotesU2' },
	{ key: 'o2', label: 'Over 2', statusField: 'waitlistTourStatusO2', notesField: 'waitlistTourStatusNotesO2' },
];

const toOption = (code) => WAITLIST_STATUS_OPTIONS.find((option) => option.value === STATUS_BY_CODE[code]) ?? null;

function StatusLight({ group, centre }) {
	const option = toOption(centre[group.statusField]);
	const notes = centre[group.notesField];
	const tone = option?.value ?? 'unset';

	return (
		<div className={`centre-status__light centre-status__light--${tone}`}>
			<span className="centre-status__dot" aria-hidden="true" />
			<div className="centre-status__text">
				<span className="centre-status__group">{group.label}</span>
				<span className="centre-status__value">{option?.label ?? 'Not set'}</span>
				{notes && <span className="centre-status__notes" title={notes}>{notes}</span>}
			</div>
		</div>
	);
}

// Read-only view of the per-centre U2/O2 waitlist/tour traffic lights set on the centre screen.
// Rendered only once the API reports the widget visible (centre-scoped users with 1–4 centres), so users
// who never get the widget never see a placeholder or error for it.
export default function CentreStatusWidget({ data, error, onRetry }) {
	if (!data?.visible) return null;

	return (
		<DashboardSection
			id="centre-status"
			title="Waitlist / Tour status"
			icon={<IoLocationOutline />}
			description="View availability by centre and age group."
			className="centre-status"
			failedSources={error ? [DASHBOARD_SOURCE.CENTRE_STATUS] : []}
			errorMessage="Could not refresh."
			onRetry={onRetry}
		>
			<ul className="centre-status__list" style={{ gridColumn: '1 / -1' }}>
				{data.centres.map((centre) => (
					<li key={centre.centreId}>
						<Link className="centre-status__centre" to={`/centres?centreId=${centre.centreId}`}>
							<span className="centre-status__name">{centre.centreName ?? 'Centre'}</span>
							<div className="centre-status__lights">
								{GROUPS.map((group) => <StatusLight key={group.key} group={group} centre={centre} />)}
							</div>
							<span className="dashboard-sr-only">, view centre</span>
							<IoChevronForward className="stat-card__chevron" aria-hidden="true" />
						</Link>
					</li>
				))}
			</ul>
		</DashboardSection>
	);
}
